import { GeneratedNoteAttestation } from '@scripsteam/scrips-signal-ds';
import { formatDateTime, parseNoZIsoDatetime } from '@/shared/lib/date-format';

// src/encounter/note-column/signed-attestation.tsx
//
// The signed-note statement of record under the generated note — green check, "Signed", and when.
// It RENDERS from the Signal DS `GeneratedNoteAttestation` (graduated from this file on
// 2026-09-23); what stays here is the one thing the DS deliberately does not own: turning the
// `.NET` wire timestamp (no `Z`, 7-digit fraction) into the display string. A value
// `parseNoZIsoDatetime` cannot parse is treated as "no timestamp".
//
// Kept as its own module (not inlined into `encounter-drawer.tsx`) because the pre-encounter host
// needs the same attestation, and two page suites `vi.mock('./encounter-drawer')` — importing it
// from the drawer would break them (`encounter-shell-page.accept-outcome.test.tsx`,
// `encounter-shell-page.narratives.test.tsx`). The drawer re-exports it.
//
// Anti-fiction lives in the DS: the SIGNED STATE decides whether it renders, the timestamp only
// whether the second line has text; neither → nothing (never "Signed just now").
export function SignedAttestation({ signed, signedAt }: { signed?: boolean; signedAt?: string }) {
  const when = signedAt ? formatDateTime(parseNoZIsoDatetime(signedAt)) : '';
  return <GeneratedNoteAttestation signed={signed} signedAtLabel={when || undefined} />;
}
